module.exports = __webpack_public_path__ + "img/logo.31a6b039.png";